export default __webpack_public_path__ + "static/media/image.olai-shop-pvt-ltd.c118a01f.png";